export default __webpack_public_path__ + "static/media/bridge.e5154704.svg";